import { handleAPI, API_VERSION_TWO } from 'utils/apiUtils'
import * as actions from './actions'

export function eligiblePeopleLoad(params = {}) {
  const url = `/${API_VERSION_TWO}/eligible_employees`

  return {
    type: actions.ELIGIBLE_PEOPLE_LOAD,
    payload: handleAPI(url, params, 'GET'),
  }
}

export function filterEligiblePeopleLoad(params = {}) {
  const url = `/${API_VERSION_TWO}/eligible_employees`

  return {
    type: actions.FILTER_ELIGIBLE_PEOPLE_LOAD,
    payload: handleAPI(url, params, 'GET'),
  }
}

export function selectUser(employee) {
  return {
    type: actions.SELECT_USER,
    payload: { employee },
  }
}

export function unSelectUser(employee) {
  return {
    type: actions.UNSELECT_USER,
    payload: { employee },
  }
}

export function setSelectUsers(employees) {
  return {
    type: actions.SET_SELECTED,
    payload: { employees },
  }
}

export function setSelectAllUsers(employees) {
  return {
    type: actions.SET_SELECTED_ALL_USERS,
    payload: { employees },
  }
}

export function setUnSelectAllUsers(employees) {
  return {
    type: actions.SET_UNSELECTED_ALL_USERS,
    payload: { employees },
  }
}

export function clearEligibleData() {
  return {
    type: actions.CLEAR_ELIGIBLE_DATA,
  }
}

export function searchUnSelected(text) {
  return {
    type: actions.SEARCH_UN_SELECTED,
    payload: text,
  }
}
export function searchSelected(text) {
  return {
    type: actions.SEARCH_SELECTED,
    payload: text,
  }
}
